// TYPES
import { USER_SET_LOADING, USER_SET_USER, USER_SET_LOGOUT } from './actions';
// INTITAL STATE
const initialState = { 
    loading: false,
    auth: false,
}

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_SET_LOADING:
            return {
                ...state,
                loading: !!action.payload,
            };
        case USER_SET_USER:
            return {
                ...state,
                userInfo: action.payload,
                auth: true
            }
        case USER_SET_LOGOUT:
            return {
                state
            }
        default:
            return state;
    }
}